import React, { FC, memo, useEffect, useState } from 'react';
import styles from '@/styles/components/promotion-card.module.scss';
import LazyImage from '@/components/common/lazy-image';
import { Button, Dropdown } from 'antd';
import { handleShare, shareMediaURl } from '@/utils/mediaShare';
import CountDateDown from '@/components/common/count-date-down';
import Image from 'next/image';
import classNames from 'classnames';

type Props = {
  promotion: any;
  language: any;
  className: any;
}

const PromotionCard: FC<Props> = memo(({ promotion, language, className }:any) => {
  const [isDisplayCard, setIsDisplayCard] = useState(false);
  const [currentUrl, setCurrentUrl] = useState('');

  useEffect(() => {
    const currentDate = new Date();
    const endTimeData = promotion?.end_time || '';
    const endTime:any = endTimeData ? new Date(endTimeData) : null;
    if(endTime && currentDate < endTime) {
      setIsDisplayCard(true);
    }
  }, []);

  useEffect(() => {
    setCurrentUrl(window.location.href);
  }, []);

  const handleSendGA = () => { 
    window?.dataLayer?.push({
        event: 'buttonClick',
        buttonTitle: promotion?.action_link?.title,
        description: language == 'zh-hk' ? promotion?.description?.substring(0, 20) : promotion?.description?.substring(0, 40),
        destinationUrl: promotion?.action_link?.href,
        pageURL: window.location.href,
        componentName: 'promotion card'
      })
  }

  return (
    <div className={classNames(className, styles.Promotion_Card_Display, { [styles.Is_Display]: isDisplayCard } )}>
      <div className={styles.Promotion_Card}>
      <div className={styles.Advertise_Wrapper}>
        <div className={styles.Image_Area}>
          <div className={styles.Image_Wrapper}>
            <LazyImage src={promotion.image?.url} alt="Dynamic_Img" className={styles.Image} width={'100%'} height={'100%'}/>
          </div>
          <div className={styles.Count_Down}>
            <Image src="/blog/icon/Clock.svg" className={styles.Clock} alt={''} width={24} height={24}/>
            <span className={styles.Text}>Ends in</span>
            <span className={styles.Time}>
            <CountDateDown endTime={promotion.end_time} />
          </span>
          </div>
        </div>
        <div className={classNames(styles.Share_Icon_Mobile, language === 'zh' ? styles.Share_Icon_Mobile_ZH : styles.Share_Icon_Mobile_EN)}>
          {promotion.more_link.title !== '' &&
            <a href={promotion.more_link.href} target="_blank" rel="noopener noreferrer">
              <Button className={styles.Button}>{promotion.more_link.title}</Button>
            </a>
          }
          <Dropdown
            className={styles.Share_Button}
            trigger={['click']}
            placement="topRight"
            arrow
            dropdownRender={(menu) => (
              <ul className={classNames(styles.Share_Option, language === 'zh' ? styles.Share_Option_ZH : styles.Share_Option_EN)}>
                <li>
                  <a href={shareMediaURl('facebook', currentUrl)} target="_blank" onClick={(e) => handleShare(e, 'facebook')} rel="noopener noreferrer">
                    <Image src="/blog/icon/FacebookBlue.svg" className={styles.Facebook_Icon} alt={''} width={25} height={25}/>
                    <span>Facebook 分享</span>
                  </a>
                </li>
                <li>
                  <a href={shareMediaURl('whatsapp', currentUrl)} target="_blank" onClick={(e) => handleShare(e, 'whatsapp')} rel="noopener noreferrer">
                    <Image src="/blog/icon/Whatsapp.svg" className={styles.Whatsapp_Icon} alt={''} width={25} height={25}/>
                    <span>Whatsapp 分享</span>
                  </a>
                </li>
                <li>
                  <a href={shareMediaURl('linkedin', currentUrl)} target="_blank" onClick={(e) => handleShare(e, 'linkedin')} rel="noopener noreferrer">
                    <Image src="/blog/icon/Ins.svg" className={styles.Linkedin_Icon} alt={''} width={25} height={25}/>
                    <span>Linkedin 分享</span>
                  </a>
                </li>
              </ul>
            )}
          >
            <Image src="/blog/icon/Share.svg" className={styles.Icon} alt={''} width={24} height={24}/>
          </Dropdown>

        </div>
        <div className={styles.Content_Area}>
          <div className={styles.Content}>
            <div className={styles.Promotion_Type}>
              <div className={styles.Tag}>{promotion.category}</div>
              <div className={styles.Title}>{promotion.title}</div>
            </div>
            <div className={styles.Bg_Content}>
              <div className={styles.Discount_Area}>
                <div>
                  <Image src="/blog/icon/Discount.svg" className={styles.Icon} alt={''} width={45} height={45}/>
                </div>
                <div>
                  <span className={styles.Sale_Label}>{promotion.sale_label}</span>
                  <span className={styles.Description}>{promotion.description}</span>
                </div>
              </div>
              <div className={styles.Extended_Description}>{promotion.extended_description}</div>
              <div className={styles.Discount_Code}>
                {language === 'zh' ? <span>優惠碼:</span> : <span>Promo code:</span>}
                <span className={styles.Code}>{promotion.marketing_product_code}</span>
              </div>
            </div>
          </div>
          <div className={classNames(styles.Btn_Row, language === 'zh' ? styles.Btn_Row_ZH : styles.Btn_Row_EN)}>
            <Button className={styles.Button} href={promotion.action_link.href} target="_blank" onClick={ ()=> handleSendGA() }>{promotion.action_link.title}</Button>
            <div className={styles.Link_Wrapper}>
              <a href={promotion.t_c_link.href} target="_blank" rel="noopener noreferrer"><span className={styles.Link}>{promotion.t_c_link.title}</span></a>
            </div>
          </div>
        </div>
        <div className={classNames(styles.Share_Icon_Pc, language === 'zh' ? styles.Share_Icon_Pc_ZH : styles.Share_Icon_Pc_EN)}>
          {promotion.more_link.title !== '' &&
            <a href={promotion.more_link.href} target="_blank" rel="noopener noreferrer">
              <Button className={styles.Button}>{promotion.more_link.title}</Button>
            </a>
          }
          <Dropdown
            className={styles.Share_Button}
            trigger={['click']}
            placement="topRight"
            arrow
            autoAdjustOverflow={true}
            dropdownRender={() => (
              <ul className={classNames(styles.Share_Option, language === 'zh' ? styles.Share_Option_ZH : styles.Share_Option_EN)}>
                <li>
                  <a href={shareMediaURl('facebook', currentUrl)} target="_blank" onClick={(e) => handleShare(e, 'facebook')} rel="noopener noreferrer">
                    <Image src="/blog/icon/FacebookBlue.svg" className={styles.Facebook_Icon} alt={''} width={25} height={25}/>
                    <span>Facebook 分享</span>
                  </a>
                </li>
                <li>
                  <a href={shareMediaURl('whatsapp', currentUrl)} target="_blank" onClick={(e) => handleShare(e, 'whatsapp')} rel="noopener noreferrer">
                    <Image src="/blog/icon/Whatsapp.svg" className={styles.Whatsapp_Icon} alt={''} width={25} height={25}/>
                    <span>Whatsapp 分享</span>
                  </a>
                </li>
                <li>
                  <a href={shareMediaURl('linkedin', currentUrl)} target="_blank" onClick={(e) => handleShare(e, 'linkedin')} rel="noopener noreferrer">
                    <Image src="/blog/icon/Ins.svg" className={styles.Linkedin_Icon} alt={''} width={25} height={25}/>
                    <span>Linkedin 分享</span>
                  </a>
                </li>
              </ul>
            )}
          >
            <Image src="/blog/icon/Share.svg" className={styles.Icon} alt={''} width={24} height={24}/>
          </Dropdown>
        </div>
      </div>
    </div>
    </div>
  )
});

export default PromotionCard;

